<template>
  <svg
    width="18.9"
    height="23"
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    version="1.1"
  >
    <g>
      <title>Layer 1</title>
      <path
        :fill="colorPrimario"
        d="m15.3,18.2l-11.8,0c-0.9,0 -1.6,-0.7 -1.6,-1.6l0,-5.5l-0.4,0c-0.8,0 -1.5,-0.7 -1.5,-1.5c0,-0.4 0.2,-0.8 0.5,-1.1l8.2,-8.1c0.4,-0.4 1.1,-0.4 1.5,0l8.3,8.2c0.6,0.6 0.6,1.6 0,2.2c-0.3,0.3 -0.7,0.4 -1.1,0.4l-0.5,0l0,5.5c-0.1,0.8 -0.8,1.5 -1.6,1.5c0,0 0,0 0,0zm-5.9,-16.7l-8,7.9c-0.1,0.1 -0.1,0.1 0,0.2c0,0 0.1,0 0.1,0l1.8,0l0,6.9c0,0.1 0.1,0.2 0.2,0.2l0,0l11.8,0c0.1,0 0.2,-0.1 0.2,-0.2l0,0l0,-6.8l1.9,0c0.1,0 0.1,-0.1 0.1,-0.1c0,0 0,-0.1 0,-0.1l-8.1,-8z"
        class="st0"
        id="Trazado_8184"
      />
      <path
        :fill="colorPrimario"
        d="m6.8,11l5.3,0l0,7.2l-5.3,0l0,-7.2zm3.9,1.3l-2.6,0l0,4.4l2.6,0l0,-4.4z"
        class="st0"
        id="Rectángulo_4665"
      />
    </g>
  </svg>
</template>
<script>
export default {
};
</script>